const C = require("../constants");
const initial_data = {open: false, product:{id:null, name:'',}};

function ProductPricesDialogReducer(state = initial_data, action) {
    switch (action.type) {
        case C.PRODUCT_PRICES_DIALOG:
            return action.data;
        default:
            return state;
    }
}

export default ProductPricesDialogReducer;


// WEBPACK FOOTER //
// ./src/reducers/ProductPricesDialogReducer.js